// ─────────────────────────────────────────────────────────────────────────────
// API-ORIGIN-001 — EINE Quelle für den API-/Socket-Origin.
//
// Vorher stand an drei Stellen (ReviewInboxContext, LiveMap, LocationTrust) identisch:
//     io(process.env.REACT_APP_API_URL?.replace('/api', '') || 'https://localhost:5001')
//
// `String.replace` ersetzt das ERSTE Vorkommen — und das steckt im `//api` des Hostnamens:
//     "https://api.voogo.de/api".replace('/api','')  ->  "https:/.voogo.de/api"
// socket.io baute daraus Requests gegen den Host `https` (`https://https/socket.io/?…`),
// die endlos mit ERR_NAME_NOT_RESOLVED scheiterten und die Konsole fluteten.
//
// Tückisch: lokal fällt es NICHT auf, weil "http://localhost:5001/api" kein `//api`
// enthält und der naive replace dort zufällig das Richtige tut. Nur Produktion brach.
//
// Korrekt ist der geparste Origin (Schema + Host + Port) — nie String-Ersetzung.
// ─────────────────────────────────────────────────────────────────────────────

/** Fallback für lokale Entwicklung, wenn REACT_APP_API_URL fehlt. */
export const DEFAULT_API_ORIGIN = 'https://localhost:5001';

/**
 * Liefert den Origin, unter dem der Socket.IO-Server erreichbar ist.
 * Fail-safe: bei fehlender/unparsbarer Konfiguration der lokale Default —
 * nie eine halb ersetzte, kaputte URL.
 */
export function apiOrigin(apiUrl = process.env.REACT_APP_API_URL) {
  if (typeof apiUrl !== 'string' || !apiUrl.trim()) return DEFAULT_API_ORIGIN;
  try {
    return new URL(apiUrl).origin;
  } catch (_) {
    return DEFAULT_API_ORIGIN;
  }
}

export default apiOrigin;
